<template>
  <div class="message email-box disp-scroll">
    <b-tabs>
      <b-tab-item label="基本設定" class="tab-email-box">
        <div class="option-box">
          <p>件名</p>
          <input
            class="input is-small"
            placeholder="例：件名を入力"
            :value="emailParameter['title']"
            @input="updateTitle($event.target.value)"
            :disabled="scenarioEdit.is_confirm"
          />
        </div>
        <div class="option-box">
          <p>FROM</p>
          <input
            class="input is-small"
            placeholder="例：メールアドレスを入力"
            :value="emailParameter['from']"
            @input="updateFrom($event.target.value)"
            :disabled="scenarioEdit.is_confirm"
          />
        </div>
        <div class="option-box">
          <p>TO</p>
          <input
            class="input is-small"
            placeholder="例：メールアドレスを入力"
            :value="emailParameter['to']"
            @input="updateTo($event.target.value)"
            :disabled="scenarioEdit.is_confirm"
          />
        </div>
        <div class="option-box">
          <p>CC</p>
          <input
            class="input is-small"
            placeholder="例：メールアドレスを入力"
            :value="emailParameter['cc']"
            @input="updateCc($event.target.value)"
            :disabled="scenarioEdit.is_confirm"
          />
        </div>
        <div class="option-box">
          <p>BCC</p>
          <input
            class="input is-small"
            placeholder="例：メールアドレスを入力"
            :value="emailParameter['bcc']"
            @input="updateBcc($event.target.value)"
            :disabled="scenarioEdit.is_confirm"
          />
        </div>
        <p class="content-title">
          <span class="mdi mdi-circle-edit-outline -right-8px"></span
          >メールの内容を入力してください。
        </p>
        <quill-editor
          :value="scenarioEdit.mainmessage"
          @input="updateMainMessage($event)"
          ref="quillEditor"
          :options="options"
          :disabled="scenarioEdit.is_confirm"
        />
        <p class="comment">(※1) __email__と入力すると訪問者のEmailに沿って変換されます。</p>
        <p class="comment">(※2) __applicant__と入力すると訪問者のお名前に沿って変換されます。</p>
        <p class="comment">(※3) __point__と入力するとシナリオの設定値に沿って変換されます。</p>
        <p class="comment">
          (※4)
          __video__とメール内容に入力すると日程自動調整で設定されていた場合に動画面接リンクに変換されます。
        </p>
        <p class="comment">
          (※5)
          __date_modify__とメール内容に入力すると日程自動調整で設定されていた場合に訪問者向け日程変更リンクに変換されます。
        </p>
        <p class="comment">
          (※6)
          __received_form__とメール内容に入力すると返信用フォームのリンクに変換されます。
        </p>
        <p class="comment">
          (※7)
          __applicanturl__とメール内容に入力すると応募者の詳細画面へのURLに変換されます。
        </p>
        <p class="comment">
          (※8) FROMに特に記載がない場合はHRモンスター（noreply@hr-monster.io）からお送りいたします。
        </p>
        <p class="comment">(※9) FROMには引用リスト内のパラメータを使用することができません。</p>
        <p class="comment">(※10) メールの宛先はカンマ区切りで複数指定できます。</p>
      </b-tab-item>
      <b-tab-item label="アフターフォロー設定" class="tab-email-box">
        <div class="tab-box-form">
          <div class="tab-box-left">
            <p style="text-align: left">
              <b>送付スケジュール</b>
              <br />
            </p>
          </div>
          <div class="tab-box-right">
            <b-numberinput
              size="is-small"
              style="width: 100px"
              :editable="false"
              :value="emailParameter['after']"
              @input="updateAfter($event)"
              min="0"
              max="90"
              controls-position="compact"
              :disabled="scenarioEdit.is_confirm"
            >
            </b-numberinput>
            日後
          </div>
        </div>
        <div v-if="emailParameter['after']" class="tab-box-form">
          <div class="tab-box-left">
            <p style="text-align: left">
              <b>即日送付</b>
              <br />
              <span style="color: #666; font-size: 12px">
                ONにするとアフターフォローとは別に即日送付されます。
              </span>
            </p>
          </div>
          <div class="tab-box-right">
            <b-switch
              style="width: 100%"
              :value="emailParameter['is_same_day']"
              @input="updateIsSameDay($event)"
              :disabled="scenarioEdit.is_confirm"
            >
            </b-switch>
          </div>
        </div>
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
export default {
  props: {
    emailParameter: {
      type: Object,
      required: true,
    },
    scenarioEdit: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
  },
  methods: {
    updateTitle(value) {
      this.$emit('update-title', value)
    },
    updateFrom(value) {
      this.$emit('update-from', value)
    },
    updateTo(value) {
      this.$emit('update-to', value)
    },
    updateCc(value) {
      this.$emit('update-cc', value)
    },
    updateBcc(value) {
      this.$emit('update-bcc', value)
    },
    updateMainMessage(value) {
      this.$emit('update-mainmessage', value)
    },
    updateAfter(value) {
      this.$emit('update-after', value)
    },
    updateIsSameDay(value) {
      this.$emit('update-same-day', value)
    },
  },
}
</script>

<style scoped lang="scss">
.email-box {
  padding: 8px;
  background-color: white;
  .tab-email-box {
    padding: 8px;
    padding-top: 16px;
  }
  .option-box {
    display: flex;
    margin: 8px 0;
    p {
      text-align: left;
      font-weight: bold;
      width: 64px;
    }
    input {
      width: calc(100% - 64px);
    }
  }
  .content-title {
    text-align: left;
    font-weight: bold;
  }
  .comment {
    text-align: left;
    color: grey;
    font-size: 13px;
  }
  /deep/ .ql-editor {
    min-height: 128px;
  }
  /deep/ .ql-formats {
    margin-right: 8px;
  }
  /deep/ .ql-toolbar {
    text-align: left;
  }
  .tab-box-form {
    width: 100%;
    display: flex;
    padding: 8px;
  }
  .tab-box-left {
    width: 40%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .tab-box-right {
    width: 60%;
    font-size: 13px;
    padding: 10px;
    justify-content: flex-start;
    display: flex;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/chatbot/scenarioEdit/ScenarioEditEmail.vue